import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { ProcessFlow } from "./ProcessFlow";

export const HeroManual = () => {
  const { t } = useLanguage();

  return (
    <section className="relative min-h-screen flex flex-col justify-between px-4 md:px-8 py-10 md:py-12 overflow-hidden">
      {/* Main Content Container */}
      <div className="w-full max-w-[1400px] mx-auto relative z-10 flex-1 flex flex-col">
        {/* Top - EYA Logo */}
        <div className="text-center mb-10 md:mb-16 fade-in">
          <div className="flex items-center justify-center gap-3 md:gap-4 mb-5 md:mb-6 w-full md:w-1/2 mx-auto">
            <span
              className="text-white font-extrabold"
              style={{
                fontFamily: "var(--font-eurostile)",
                fontSize: "clamp(56px, 14vw, 160px)",
                letterSpacing: "0.12em",
                fontWeight: "900",
              }}
            >
              E
            </span>
            <span
              className="text-white font-extrabold"
              style={{
                fontFamily: "var(--font-eurostile)",
                fontSize: "clamp(56px, 14vw, 160px)",
                letterSpacing: "0.12em",
                fontWeight: "900",
              }}
            >
              Y
            </span>
            <span
              className="font-extrabold text-[#5a6e54]"
              style={{
                fontFamily: "var(--font-eurostile)",
                fontSize: "clamp(56px, 14vw, 160px)",
                letterSpacing: "0.12em",
                fontWeight: "900",
              }}
            >
              A
            </span>
          </div>

          <div className="border-t border-b border-gray-700 py-3">
            <h2
              className="uppercase font-bold text-2xl md:text-4xl text-gray-400"
              style={{
                fontFamily: "var(--font-eurostile)",
                letterSpacing: "0.14em",
                fontWeight: "900",
              }}
            >
              {t("companyName")}
            </h2>
          </div>
        </div>

        {/* Process Flow */}
        <div className="mb-10 md:mb-16 fade-in relative flex-1 flex items-center justify-center">
          <ProcessFlow />

          {/* Desktop-only vertical text */}
          <div className="hidden xl:block absolute right-[10%] top-1/2 -translate-y-1/2">
            <div
              className="rotate-180 origin-center whitespace-nowrap"
              style={{ writingMode: "vertical-rl" }}
            >
              <span
                className="uppercase font-bold text-5xl opacity-50 text-[#9CA3AF]"
                style={{
                  fontFamily: "var(--font-eurostile)",
                  fontWeight: "900",
                  letterSpacing: "0.25em",
                }}
              >
                {t("machineLanguage")}
              </span>
            </div>
          </div>
        </div>

        {/* Title Section */}
        <div className="text-center mb-12 md:mb-20 fade-in">
          <div className="border-t border-b border-gray-700 py-6 md:py-8">
            <h1
              className="uppercase font-normal text-[#9CA3AF] opacity-50 leading-tight px-2"
              style={{
                fontFamily: "var(--font-eurostile)",
                fontSize: "clamp(34px, 7vw, 105px)",
                letterSpacing: "0.14em",
                fontWeight: "400",
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              {t("systemsControl")}
            </h1>
          </div>
        </div>

        {/* Bottom Navigation */}
        <div className="flex flex-col md:flex-row md:items-start gap-6 md:gap-0 fade-in">
          <div className="flex flex-col space-y-4 w-full md:w-[35%]">
            <a
              href="#services"
              className="uppercase hover:text-[#5a6e54] transition-colors text-2xl md:text-4xl text-gray-300"
              style={{
                fontFamily: "var(--font-eurostile)",
                fontWeight: "900",
                letterSpacing: "0.14em",
              }}
            >
              {t("service")}
            </a>
            <a
              href="#about"
              className="uppercase hover:text-[#5a6e54] transition-colors text-2xl md:text-4xl text-gray-300"
              style={{
                fontFamily: "var(--font-eurostile)",
                fontWeight: "900",
                letterSpacing: "0.14em",
              }}
            >
              {t("about")}
            </a>
            <a
              href="#contact"
              className="uppercase hover:text-[#5a6e54] transition-colors text-2xl md:text-4xl text-gray-300"
              style={{
                fontFamily: "var(--font-eurostile)",
                fontWeight: "900",
                letterSpacing: "0.14em",
              }}
            >
              {t("contact")}
            </a>
          </div>

          {/* Separator line only on desktop */}
          <div className="hidden md:block h-32 w-[1px] bg-gray-700 ml-8"></div>
        </div>
      </div>

      {/* Background watermark */}
      <div
        className="absolute bottom-24 right-10 md:right-24 text-[4rem] md:text-[5rem] font-bold text-white/5 select-none pointer-events-none"
        style={{ fontFamily: "var(--font-eurostile)" }}
      >
        1729
      </div>
    </section>
  );
};
